export default "__VITE_ASSET__kO9QXE2b__"